import { useEffect, useState } from 'react'
import { Container, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { AutoPlayOptionType, autoPlayService } from '../../domain/autoPlay'
import { useAutoPlayStore } from '../../domain/autoPlay/store/autoPlayStore'
import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { Button } from '../../UI/Button'
import { Image } from '../../UI/Image'

interface AutoPlayOptionProps {
  x: number
  y: number
  isHighlighted: boolean
  radius: number
  text: AutoPlayOptionType
}
const autoNumColors = { isHighlighted: '#FFFFFF', normal: '#F0E1D4' }
const width = 180
const height = 75

export const AutoPlayOptionV2 = (props: AutoPlayOptionProps) => {
  const [current] = useAutoPlayStore(x => [x.current])
  const [isEnable, setIsEnable] = useState(true)

  useEffect(() => {
    if (props.text === current) {
      setIsEnable(false)
    }
    else {
      setIsEnable(true)
    }
  }, [current, props.text])

  return (
    <Container
      position={[props.x, props.y]}
      eventMode="static"
      cursor="pointer"
      onpointertap={() => {
        soundManager.play(SoundType.buttonConfirm)
        autoPlayService.select(props.text)
      }}
    >
      <Button
        name={`auto_option_bg_${current}`}
        defaultView="auto_option_normal_v2"
        hoverView="auto_option_hover_v2"
        pressedView="auto_option_normal_v2"
        disabledView="auto_option_unable_v2"
        enabled={isEnable}
        x={0}
        y={0}
        width={width}
        height={height}
        onPress={() => {
          //
        }}
      />

      {
        props.text === 'infinity'
          ? (
              <Image
                x={width / 2}
                y={height / 2}
                anchor={0.5}
                image={props.isHighlighted ? 'auto_icon_infinity_v2' : 'auto_icon_infinity_close_v2'}
              />
            )
          : (
              <Text
                text={props.text.toString()}
                x={width / 2}
                y={height / 2}
                anchor={0.5}
                style={
                  new TextStyle({
                    fontSize: 42,
                    fill: props.isHighlighted ? autoNumColors.isHighlighted : autoNumColors.normal,
                    align: 'center',
                  })
                }
              />
            )
      }
    </Container>
  )
}
